import { Provider } from "react-redux";
import { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useParams,
  useLocation,
} from "react-router-dom";
import store from "./store/store";
import "./css/componentscss/Common.css";
import "./css/componentscss/CommonFont.css";
import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Services from "./pages/Services";
import LabsList from "./pages/Labs/LabsList";
import About from "./pages/About";
import Careers from "./pages/Careers";
import ProjectsList from "./pages/Projects/ProjectsList";
import NewsList from "./pages/News/NewsList";
import Contact from "./pages/Contact";
import { clientUrls } from "./constants/ClientUrls";
import CookieModal from "./components/CookieModal";
import PageNotFound from "./components/PageNotFound";
import CompanyProfile from "./pages/CompanyProfile";
import { getLanguage } from "./constants/GeneralConstants";
import ProjectDescription from "./pages/Projects/ProjectDescription";
import NewsDescription from "./pages/News/NewsDescription";
import LabsDescription from "./pages/Labs/LabsDescription";
import ReactPage from "./pages/react/ReactPage";
import Resolve from "./components/services/Resolve";
import PenTesting from "./components/services/PenTesting";
import ItSupport from "./pages/itsupport/ItSupport";
import NetworkError from "./components/NetworkError";
import Legal from "./components/Legal";
import { HelmetProvider } from "react-helmet-async";
import useWindowWidth from "./components/services/useWindowWidth";
import SoftwareTesting from "./components/services/SoftwareTesting";

const App = () => {
  const [showModal, setShowModal] = useState(false);
  const [isOnline, setIsOnline] = useState(true);
  const windowWidth = useWindowWidth();

  const location = useLocation();
  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowModal(true);
    }
    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setShowModal(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "false");
    setShowModal(false);
  };

  const onClosingModal = () => {
    setShowModal(false);
  };
  const cookieMobileLogic = () => {
    if (windowWidth < 640) {
      return !window.location.href.includes("privacy-policy");
    } else {
      return true;
    }
  };
  useEffect(() => {
    document.body.classList.remove("heading-dela", "heading-noto-bold");
    if (["en", "fr-ca"].includes(getLanguage())) {
      document.body.classList.add("heading-dela");
    } else {
      document.body.classList.add("heading-noto-bold");
    }
  }, [getLanguage(), location]);
  if (!isOnline) {
    return (
      <>
        <Provider store={store}>
          <Header />
          <NetworkError />
          <Footer />
        </Provider>
      </>
    );
  }
  return (
    <Provider store={store}>
      <>
        {/* <HelmetProvider> */}
        <ScrollToTop />
        <Header />
        <Routes>
          {/* Protected Routes */}
          <Route exact path={clientUrls.home} element={<Home />} />
          <Route exact path={clientUrls.homeWithLanguage} element={<Home />} />
          <Route exact path={clientUrls.subservices} element={<Services />} />
          <Route
            exact
            path={clientUrls.subservicesWithLanguage}
            element={<Services />}
          />
          <Route exact path={clientUrls.about} element={<About />} />
          <Route
            exact
            path={clientUrls.aboutWithLanguage}
            element={<About />}
          />
          <Route
            exact
            path={clientUrls.companyProfile}
            element={<CompanyProfile />}
          />
          <Route
            exact
            path={clientUrls.companyProfileWithLanguage}
            element={<CompanyProfile />}
          />
          <Route exact path={clientUrls.careers} element={<Careers />} />
          <Route
            exact
            path={clientUrls.careersWithLanguage}
            element={<Careers />}
          />
          <Route exact path={clientUrls.projects} element={<ProjectsList />} />
          <Route
            exact
            path={clientUrls.projectsWithLanguage}
            element={<ProjectsList />}
          />
          <Route
            exact
            path={clientUrls.projectsDescription}
            element={<ProjectDescription />}
          />
          <Route
            exact
            path={clientUrls.projectsDescriptionWithLanguage}
            element={<ProjectDescription />}
          />
          <Route exact path={clientUrls.news} element={<NewsList />} />
          <Route
            exact
            path={clientUrls.newsWithLanguage}
            element={<NewsList />}
          />
          <Route
            exact
            path={clientUrls.newsDescription}
            element={<NewsDescription />}
          />
          <Route exact path={clientUrls.pentesting} element={<PenTesting />} />
          <Route
            exact
            path={clientUrls.newsDescriptionWithLanguage}
            element={<NewsDescription />}
          />
          <Route exact path={clientUrls.labs} element={<LabsList />} />
          <Route
            exact
            path={clientUrls.labsWithLanguage}
            element={<LabsList />}
          />
          <Route
            exact
            path={clientUrls.labsDescription}
            element={<LabsDescription />}
          />
          <Route
            exact
            path={clientUrls.labsDescriptionWithLanguage}
            element={<LabsDescription />}
          />
          <Route exact path={clientUrls.contact} element={<Contact />} />
          <Route
            exact
            path={clientUrls.contactWithLanguage}
            element={<Contact />}
          />
          <Route exact path={clientUrls.subReactPage} element={<ReactPage />} />
          <Route
            exact
            path={clientUrls.subReactPagesWithLanguage}
            element={<ReactPage />}
          />
          <Route exact path={clientUrls.subResolvePage} element={<Resolve />} />
          <Route
            exact
            path={clientUrls.subResolvePagesWithLanguage}
            element={<Resolve />}
          />
          <Route exact path={clientUrls.pentesting} element={<PenTesting />} />
          <Route
            exact
            path={clientUrls.pentestingWithLanguage}
            element={<PenTesting />}
          />
          <Route
            exact
            path={clientUrls.softwareTesting}
            element={<SoftwareTesting />}
          />
          <Route
            exact
            path={clientUrls.softwareTestingWithLanguage}
            element={<SoftwareTesting />}
          />
          <Route
            exact
            path={clientUrls.websiteTermsOfUsage}
            element={<Legal />}
          />
          <Route
            exact
            path={clientUrls.websiteTermsOfUsageWithLanguage}
            element={<Legal />}
          />
          <Route exact path={clientUrls.privacyPolicy} element={<Legal />} />
          <Route
            exact
            path={clientUrls.privacyPolicyWithLanguage}
            element={<Legal />}
          />
          <Route
            exact
            path={clientUrls.modernSlaveryStatement}
            element={<Legal />}
          />
          <Route
            exact
            path={clientUrls.modernSlaveryStatementWithLanguage}
            element={<Legal />}
          />
          <Route exact path={clientUrls.itSupport} element={<ItSupport />} />

          <Route exact path="*" element={<PageNotFound />} />
        </Routes>
        {/* <Footer /> */}
        {showModal && cookieMobileLogic() && (
          <CookieModal
            onAccept={handleAccept}
            onReject={handleReject}
            onClose={onClosingModal}
          />
        )}
      </>
    </Provider>
  );
};

export default App;
